/**
 * @memberOf Tee
 * @class Values for each side (left, top, right and bottom) as percentage margins.
 */
export class Margins {
	constructor() {
		this.left = 2
		this.top = 2
		this.right = 2
		this.bottom = 2
	}

	apply(r) {
		const w = r.width
		const h = r.height

		r.x += w * this.left * 0.01
		r.width -= w * Math.min(100, this.left + this.right) * 0.01

		r.y += h * this.top * 0.01
		r.height -= h * Math.min(100, this.top + this.bottom) * 0.01
	}
}
